module.exports = __webpack_public_path__ + "img/icon-jixu.c8d230b7.png";